import { Grid, useMediaQuery } from '@material-ui/core';
import React, { useState } from 'react';
import { Tile } from "../tile";
import { StyledTwistyWrapper, TileListWrapper, TilePadding } from './Style';
import { Twisty } from "../twisty";
import { Magnetic as Mi } from "../../styles";
import { AlbumTwisty } from './AlbumTwisty';
export const Album = (props) => {
    const [isExpanded, setIsExpanded] = useState(true);
    const toggleCollapse = () => {
        setIsExpanded(!isExpanded);
    };
    const handleSelectAll = () => {
        if (props.onSelectAll) {
            props.onSelectAll(props.id, props.groupName);
        }
    };
    const handleDeselectAll = () => {
        if (props.onDeselectAll) {
            props.onDeselectAll(props.id, props.groupName);
        }
    };
    const isSubLabelMaxWidthReached = useMediaQuery(`(max-width: ${Mi.layoutBreakpointSm})`);
    const handleUpdateTileDescription = (tileId, description) => {
        if (props.onUpdateTileDescription) {
            props.onUpdateTileDescription(tileId, description);
        }
    };
    const handleTileClick = (tileId, isSelected) => {
        if (props.onTileClick) {
            props.onTileClick(tileId, isSelected, props.groupName);
        }
    };
    const anyTilesSelected = props.tiles.some(tile => tile.isSelected);
    const allTilesSelected = props.tiles.length > 0 && props.tiles.every(tile => tile.isSelected);
    const renderTiles = () => {
        return props.tiles.map((tile, index) => {
            return (React.createElement(TilePadding, { key: tile.id, id: `tile-wrapper-${index}` },
                React.createElement(Tile, { id: `tile-${index}`, index: index, tile: tile, mode: props.mode, smallTileWidth: props.smallTileWidth, smallTileHeight: props.smallTileHeight, onTileClick: handleTileClick, onUpdateDescription: handleUpdateTileDescription, translateFn: props.translateFn, shouldShowThumbnailForPdf: props.shouldShowThumbnailForPdf, labelValue: tile.labelValue })));
        });
    };
    return Array.isArray(props.tiles) && props.tiles.length ? (props.shouldShowGroup ? (React.createElement(Grid, { container: true },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(StyledTwistyWrapper, null,
                React.createElement(Twisty, { id: props.id, label: React.createElement(AlbumTwisty, { headerText: props.header, isSelectModeOn: props.isSelectModeOn, fontSize: props.fontSize, onSelectAll: handleSelectAll, onDeselectAll: handleDeselectAll, translateFn: props.translateFn, subHeaderText: !isSubLabelMaxWidthReached ? props.subHeader : undefined, areAllTilesSelected: allTilesSelected, areAnyTilesSelected: anyTilesSelected }), isExpanded: isExpanded, onToggle: toggleCollapse, fontSize: props.fontSize },
                    React.createElement(TileListWrapper, { container: true, id: `tile-list-wrapper-${props.id}`, tilesGap: props.tilesGap, panelBackgroundColor: props.panelBackgroundColor, isSelectModeOn: props.isSelectModeOn }, renderTiles())))))) : (React.createElement("div", { id: props.id }, renderTiles()))) : null;
};
//# sourceMappingURL=Album.js.map